import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const PrenatalStartMonth = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();


    return (
        <SimpleBars
            title={'Mês de Início do Pré-Natal'}
            horizontal={true}
            subtitles={chartData?.prenatalStartMonth?.map((item) => item.description)}
            values={chartData?.prenatalStartMonth?.map((item) => item.total  ||  0)}
        />
    );
};
